<div class="selection-box-bar-container">
	<span class="selection-box-bar-title-with-icon">
		<div class="selection-box-bar-title">{{title}}</div>
		 <i *ngIf="diagramPath" class="cp-icon-color-5"
		   [ngClass] ="displayDiagram ? 'cp-icon-hide' : 'cp-icon-show'"
		   [title]="displayDiagram ? 'Hide image' : 'Show image'"
		   (click)="onDiagramIconClick()"></i>
	</span>

	<div class="procedure-actions">
		<span *ngIf="searchable">
			<cp-sb-search [focus]="focus"
						  [disabled]="disabled"
						  [placeholderTranslationKey]="placeholderTranslationKey"
						  (searchItems)="onSearch($event)">
			</cp-sb-search>
		</span>
		<ng-content></ng-content>
	</div>
</div>
